<template>
  <div class="view">
    <Title title="ユーザー"/>
    <UserNewMain />
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import UserNewMain from '@/components/User/NewMain'

export default {
  components: {
    Title,
    UserNewMain
  }
}
</script>
